export const SET_VIDEOS_LIST = 'SET_VIDEOS_LIST';